// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------

import { cadastrarEmpreendimentoService } from "../../../services/cadastrarEmpreendimentoService";

export const useCadastrarEmpreendimento = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const cadastrarEmpreendimento = async (valuesEmp: any) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      delete valuesEmp.estado;

      const cadastrarEmp = await cadastrarEmpreendimentoService(valuesEmp);

      if (cadastrarEmp) {
        setSuccess(true);
        setError(false);
      } else {
        setError(true);
      }
    } catch (error) {
      setError(true);
      console.error(error);
    } finally {
      setIsLoading(false); // Sempre desativa o carregamento
    }
  };

  return { cadastrarEmpreendimento, isLoading, isSuccess, error, success };
};
